import React from "react";
import { FaArrowRight, FaShieldAlt, FaBuilding, FaCheckCircle } from "react-icons/fa";
import { MdPublic } from "react-icons/md";
import buildingImg from "../../assets/pub-hero-building.svg";
import overlay1 from "../../assets/pub-overlay-1.svg"; // Project Entry Screen — portrait → RIGHT side
import overlay2 from "../../assets/pub-overlay-2.svg"; // Frame — landscape       → LOWER LEFT
import overlay3 from "../../assets/pub-overlay-3.svg"; // Card 1 — landscape      → UPPER LEFT
import { useNavigate } from "react-router-dom";

const TRUST_BADGES = [
    { icon: <FaShieldAlt />, label: "Clear Audit Trail" },
    { icon: <FaCheckCircle />, label: "Authenticity Verified" },
    { icon: <MdPublic />, label: "Verified Location" },
    { icon: <FaBuilding />, label: "Made for the Job Site" },
];

const PubHero = () => {
    const navigate = useNavigate();

    return (
        <section className="pub-hero">
            {/* Decorative blue glow */}
            <div className="pub-hero-glow" />

            {/* ── Left: text ── */}
            <div className="pub-hero-left">
                <p className="pub-hero-eyebrow">Trust, built into every record.</p>
                <h1 className="pub-hero-title">
                    Bridge <span>off-site</span> teams and <span>on-site </span> reality.
                </h1>
                <p className="pub-hero-subtitle">
                    Every construction update becomes a tamper-evident record — giving every party a clear audit trail and a single source of truth, without the constant site visits.
                </p>
                <div className="pub-hero-actions">
                    <button
                        className="filled-button"
                        onClick={() => window.open("https://web.conra.net", "_blank")}
                    >
                        Get Started <FaArrowRight style={{ marginLeft: 6 }} />
                    </button>
                    <button
                        className="outlined-button"
                        onClick={() => {
                            const el = document.getElementById("features");
                            if (el) el.scrollIntoView({ behavior: "smooth" });
                        }}
                    >
                        See how verification works
                    </button>
                </div>

                {/* Trust badges row */}
                <div className="pub-hero-badges">
                    {TRUST_BADGES.map((b, i) => (
                        <span key={i} className="pub-hero-badge">
                            <span className="pub-hero-badge-icon">{b.icon}</span>
                            {b.label}
                        </span>
                    ))}
                </div>
            </div>

            {/* ── Right: building + 3 overlays ── */}
            <div className="pub-hero-right">
                <img src={buildingImg} alt="Construction building" className="pub-hero-building-img" />

                {/* Gradient: fades right edge of image to white */}
                <div className="pub-hero-img-gradient" />

                {/* overlay3 = Card 1 (landscape) → UPPER LEFT */}
                <img src={overlay3} alt="Project card" className="pub-hero-ov pub-hero-ov--3" />

                {/* overlay2 = Frame (landscape) → LOWER LEFT */}
                <img src={overlay2} alt="Project frame" className="pub-hero-ov pub-hero-ov--2" />

                {/* overlay1 = Project Entry Screen (portrait) → RIGHT side */}
                <img src={overlay1} alt="Project screen" className="pub-hero-ov pub-hero-ov--1" />
            </div>
        </section>
    );
};

export default PubHero;
